import { h } from 'preact';
import { attachModalTrigger } from '../theme/modal/attachTrigger';
import { Content } from './content';
import { t } from '../theme/locales';
export const init = async ()=>{
    if (typeof window === 'undefined') return;
    // Consumer components should call `openModal` via their own callbacks.
    // Some templates still render a plain server-side button with
    // `data-modal-open='gift-wrapping-modal'`. Attach a capture-phase click
    // handler so those buttons will open the react modal too.
    attachModalTrigger({
        selector: '[data-modal-open]',
        id: 'embroidery-modal',
        ariaLabel: t('embroidery.modal_aria_label'),
        createVnode: (targetEl)=>h(Content, {
                targetEl
            })
    });
};
export default init;
